import { render, staticRenderFns } from "./WarnConfigView.vue?vue&type=template&id=fc3f7056&"
import script from "./WarnConfigView.vue?vue&type=script&lang=js&"
export * from "./WarnConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports